export const SOURCE_IPAC = 'ipaconline';
export const SOURCE_EF = 'ecolefrancaise';
export const DATA_LAYER = global.window?.Config.dataLayerId;

export const sourceOriginLead = global.window?.Config.sourceOriginLead ?? SOURCE_EF;

export const isIpac = sourceOriginLead === SOURCE_IPAC;

export const urlZohoLead = 'https://lecolefrancaise.fr/formulaire-alternance-generique/';
